<template>
    <b-row>
        <b-col cols="12" md="12">
            <component-header
                title="View Return & Cancellation Policy"
                :hasSearch="false"
                :hasCreate="false"
                :hasClear="false"
                :hasReload="false"
                :hasback="true"
                @back-press="$router.push({ path: '/setup/policy' })"
            />
        </b-col>
        <b-col cols="12" md="12">
            <b-card class="custome-card">
                <form>
                    <b-row>
                        <b-col cols="12" sm="12" md="6" class="mt-2">
                            <label for="productType">Product Type</label>
                            <multiselect
                                v-model="productType"
                                tag-placeholder="Add this as new product type"
                                placeholder="Select Product Type"
                                label="name"
                                :options="productTypeList"
                                track-by="_id"
                                :multiple="true"
                                :taggable="false"
                                :open-direction="'bottom'"
                                disabled
                            ></multiselect>
                        </b-col>
                        <b-col cols="12" sm="12" md="6" class="mt-2">
                            <label for="planName"
                                >Return & Replacement Window Days</label
                            >
                            <b-form-input
                                id="planName"
                                inputType="text"
                                placeholder="Enter Return Window(in days)"
                                v-model="returnWindow"
                                disabled
                            />
                        </b-col>
                        <b-col cols="12" sm="6" md="4" class="mt-4">
                            <div class="switch-readonly">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Allow Return"
                                    v-model="allowReturn"
                                >
                                </v-switch>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6" md="4" class="mt-4">
                            <div class="switch-readonly">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Allow Replacement"
                                    v-model="allowReplacement"
                                >
                                </v-switch>
                            </div>
                        </b-col>
                        <b-col md="4" class="mt-4">
                            <div class="switch-readonly">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Return Approval Require"
                                    v-model="returnApproval"
                                >
                                </v-switch>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="12" md="6">
                            <b-form-group class="mt-2 ml-3">
                                <label>Refund Mode</label>
                                <b-form-checkbox-group
                                    id="refund-mode-group"
                                    v-model="selectedRefundMode"
                                    :options="refundModeOptions"
                                    name="refund-modes"
                                ></b-form-checkbox-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="6">
                            <b-form-group class="mt-2 ml-3">
                                <label>Allow Cancellation</label>
                                <b-form-radio-group
                                    id="radio-group-2"
                                    v-model="selectedCancellation"
                                    disabled
                                >
                                    <b-form-radio value="BEFORE_APPROVAL"
                                        >Before Approval</b-form-radio
                                    >
                                    <b-form-radio value="BEFORE_DELIVERY"
                                        >Before Delivery</b-form-radio
                                    >
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <label>Note</label>
                            <textarea
                                rows="4"
                                cols="30"
                                id="title"
                                class="form-control custom-transform-class"
                                inputType="text"
                                maxlength="300"
                                v-model="note"
                                disabled
                            ></textarea>
                        </b-col>
                    </b-row>
                </form>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader/index.vue";
import { mapState } from "vuex";
import returnPolicyCatalogMixin from "@/views/setup/return-policy/returnPolicyCatalogMixin";
import { REFUND_MODE_OPTIONS } from "@/views/setup/return-policy/constants";

export default {
    name: "View Return Policy",
    components: {
        ComponentHeader,
    },
    mixins: [returnPolicyCatalogMixin],
    data() {
        return {
            productType: [],
            productTypeList: [],
            allowReturn: false,
            allowReplacement: false,
            returnWindow: "",
            returnApproval: false,
            note: "",
            selectedRefundMode: [],
            selectedCancellation: null,
            refundModeOptions: REFUND_MODE_OPTIONS,
        };
    },
    computed: {
        ...mapState({
            getPolicyById: (state) => state.returnPolicy.returnPolicyDetails,
        }),
    },
    watch: {
        getPolicyById: {
            immediate: true,
            handler(val) {
                if (val && val.length) {
                    this.assignPolicyValues(val[0]);
                }
            },
        },
        productTypeList(val) {
            if (
                this.getPolicyById &&
                this.getPolicyById.length &&
                val &&
                val.length
            ) {
                const policy = this.getPolicyById[0];
                this.productType = val.filter(
                    (item) =>
                        policy.catalogId && policy.catalogId.includes(item._id),
                );
            }
        },
    },
    methods: {
        async loadProductTypes() {
            this.productTypeList = await this.fetchProductTypeList();
        },
        async fetchPolicyDetails() {
            try {
                await this.$store.dispatch(
                    "returnPolicy/viewReturnPolicy",
                    this.$route.params.id,
                );
            } catch (error) {
                this.$toasted.error("Unable to fetch data");
            }
        },
        assignPolicyValues(policy) {
            if (this.productTypeList.length && policy.catalogId) {
                this.productType = this.productTypeList.filter((item) =>
                    policy.catalogId.includes(item._id),
                );
            }
            this.allowReturn = policy.allowReturn;
            this.allowReplacement = policy.allowReplacement;
            this.returnWindow = policy.returnWindowDays;
            this.returnApproval = policy.approvalRequired;
            this.selectedRefundMode = policy.refundMode || [];
            this.selectedCancellation =
                policy.allowCancellation === "BEFORE_APPROVAL"
                    ? "BEFORE_APPROVAL"
                    : "BEFORE_DELIVERY";
            this.note = policy.notes || "";
        },
    },
    mounted() {
        this.fetchPolicyDetails();
        this.loadProductTypes();
    },
};
</script>

<style scoped>
.radio-align {
    margin-top: 2px !important;
}
.multiselect__select {
    position: absolute;
    width: 40px;
    height: 41px !important;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;
    transition: transform 0.2s ease;
}
/* Read-only: same indigo color as edit, no disabled graying */
.switch-readonly {
    pointer-events: none;
}
</style>
